import { render, staticRenderFns } from "./ExaminResult.vue?vue&type=template&id=1b53b79e&scoped=true&"
import script from "./ExaminResult.vue?vue&type=script&lang=js&"
export * from "./ExaminResult.vue?vue&type=script&lang=js&"
import style0 from "./ExaminResult.vue?vue&type=style&index=0&id=1b53b79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53b79e",
  null
  
)

export default component.exports